<template>
    <empty-settings 
        model="le Statistiche"
    ></empty-settings>
</template>
<script>
    import EmptySettings from '@/components/common/EmptySettings'

    export default {
        name: 'analytics-options',
        components: {
            EmptySettings
        },
        props: {},
        data() {
            return {

            }
        },
        mounted() {
            this.$store.commit('endProgress')
        }
    }
</script>